module.exports = __webpack_public_path__ + "img/sdk6.2d158644.png";